import _ from 'lodash';

import { dateFormatter, getAge } from '../../helpers/helpers';

/**
 * Validates the additional guarantor fields
 * @param {Object} schema
 * @returns {Function}
 */

export default (schema) => {
    return (values, dispatch, form) => {
        return new Promise((resolve, reject) => {
            const person =
                _.find(values.people, { uid: form.uid }) ||
                _.last(values.people);

            schema
                .validate(person, { abortEarly: false })
                .then(() => {
                    let formattedDOB = dateFormatter(person.date_of_birth);
                    let age = getAge(formattedDOB);
                    if (age < 18) {
                        throw new Error('Not valid age');
                    }
                    resolve();
                })
                .catch((errors) => {
                    let formErrors = errors.inner.reduce((memo, err) => {
                        return _.setWith(memo, err.path, err.message);
                    }, {});

                    let people = Array.apply(
                        null,
                        new Array(values.people.length)
                    );
                    const existingGuarantorIndex = _.findIndex(values.people, {
                        uid: form.uid
                    });
                    const newGuarantorIndex = _.findLastIndex(
                        values.people,
                        'uid'
                    );
                    const guarantorIndex =
                        existingGuarantorIndex > -1
                            ? existingGuarantorIndex
                            : newGuarantorIndex;
                    // TODO: avoid mutation
                    people[guarantorIndex] = formErrors;
                    formErrors = _.merge({ people });
                    reject(formErrors);
                });
        });
    };
};
